import { List, Create, Details } from "../Components/index.js";

export default [
    {
        path: "/letter/archive",
        component: List,
        name: "letter.archive",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/letter/archive/create",
        component: Create,
        name: "letter.archive.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/letter/archive/:id/view",
        component: Details,
        name: "letter.details",
        meta: {
            requiresAuth: true,
        },
    },
];
